import React from "react";
import { Reveal, LineReveal } from "@/lib/motion";

const pains = [
  {
    n: "01",
    title: "You're putting in the work. But nothing's changing.",
    body: "Hard work without the right system doesn't help achieve your goals. It just exhausts you.",
  },
  {
    n: "02",
    title: "Everyone online has an opinion. Very few have evidence.",
    body: "Conflicting advice, miracle programs, and supplement culture have made fitness feel impossible to navigate. I base every training and nutrition decision on peer-reviewed research, not just what's trending.",
  },
  {
    n: "03",
    title: "Nutrition doesn't have to mean restriction.",
    body: "No fad diets, no cutting out food groups, no unsustainable rules. Just a balanced approach built around your goals, where consistency beats perfection every time.",
  },
  {
    n: "04",
    title: "You'll have someone genuinely in your corner.",
    body: "Not an app. Not an automated check-in. I'll know your name, your history, and your goals, and I will always be there when you need it.",
  },
];

export const Problem = () => {
  return (
    <section
      data-testid="problem-section"
      className="relative py-28 md:py-40 max-w-[1400px] mx-auto px-6 md:px-12"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-16 lg:gap-x-20">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <span className="text-xs uppercase tracking-[0.28em] text-white/40">The Problem</span>
            </Reveal>
            <h2 className="mt-6 font-syne font-bold tracking-tight text-4xl md:text-5xl lg:text-6xl leading-[0.98]">
              <LineReveal
                lines={["You're working", <>hard. It's just <span className="font-cormorant italic font-light text-white/60">not</span></>, "working."]}
                stagger={0.1}
              />
            </h2>
            <Reveal delay={0.2}>
              <p className="mt-8 max-w-md text-white/50 leading-relaxed font-light">
                Most people don't lack discipline. They lack a system built with
                intent.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-7 space-y-px">
          {pains.map((p, i) => (
            <Reveal key={p.n} delay={i * 0.08}>
              <div className="group relative border-t border-white/10 py-10 flex gap-8 md:gap-12 transition-colors duration-500 hover:border-white/30">
                <span className="font-cormorant italic text-4xl md:text-5xl text-white/15 transition-colors duration-500 group-hover:text-white/40 shrink-0">
                  {p.n}
                </span>
                <div>
                  <h3 className="font-syne text-xl md:text-2xl font-semibold tracking-tight">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-white/45 leading-relaxed font-light max-w-lg">
                    {p.body}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
